import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import FeaturedProjects from "@/components/FeaturedProjects";
import BuildingLineDraw from "@/components/BuildingLineDraw";
import SignatureSpotlight from "@/components/SignatureSpotlight";
import AmenitiesShowcase from "@/components/AmenitiesShowcase";
import Testimonials from "@/components/Testimonials";
import AwardsMedia from "@/components/AwardsMedia";
import JournalTeaser from "@/components/JournalTeaser";
import CtaBlock from "@/components/CtaBlock";

export default function Home() {
    return (
        <div data-testid="page-home">
            <Hero />
            <EditorialMarquee />
            <Manifesto />
            <FeaturedProjects />
            
            <BuildingLineDraw />
            <SignatureSpotlight />
            <AmenitiesShowcase />
            <AwardsMedia />
            <Testimonials />
            <JournalTeaser />
            <CtaBlock />
        </div>
    );
}
